// this file added by Bearer Web Developer
import React, { useEffect, useRef } from 'react';
import styles from './timer.module.scss';
import { observer } from 'mobx-react-lite';
import formatSecondsToMMSS from '../../cancelOrderPopupContents/formatSecondsToMMSS';

interface Props {
    onFinish?: () => void;
    withMinute?: boolean;
    cancellation: boolean;
    seconds: number;
}
const Timer: React.FC<Props> = observer(({ onFinish, withMinute = false, cancellation, seconds }) => {

    const remainingTime = useRef<number>(0);
    const timer = useRef<HTMLSpanElement | null>(null);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const endTimeRef = useRef<number>(Date.now() + (seconds * 1000));

    useEffect(() => {
        if (seconds > 0) {
            endTimeRef.current = Date.now() + (seconds * 1000);
            if (timer?.current) {
                intervalRef.current = setInterval(() => {
                    remainingTime.current = Math.max(0, Math.round((endTimeRef.current - Date.now()) / 1000));
                    if (timer.current) timer.current.textContent =
                        withMinute ? formatSecondsToMMSS(remainingTime.current) : remainingTime.current.toString();
                    if (remainingTime.current === 0 && intervalRef.current) {
                        clearInterval(intervalRef.current);
                        console.log("Timer finished");
                        onFinish?.();
                    }
                }, 1000);
            }
            return () => {
                // Cleanup code to run when the component unmounts
                if (intervalRef.current) clearInterval(intervalRef.current);
            };
        } else {
            if (!cancellation) onFinish?.();
            if (intervalRef.current) clearInterval(intervalRef.current);
        }
    }, [seconds]);

    return (
        <div className={styles.timer}>
            {
                !cancellation ?
                    <div className={styles.time}>
                        <img src={"/timer-green.svg"} alt="" width={20} height={20} />
                        <p>FREE cancellation ends in: <span ref={timer}>{formatSecondsToMMSS(seconds)}</span></p>
                    </div> :
                    <div className={styles.cancel}>
                        <img src={"/note-red.svg"} alt="" width={20} height={20} />
                        <p>Cancellation will incur a fee.</p>
                    </div>
            }
        </div>
    )
})
export default Timer;